export interface AdjustmentState {
  brightness: number;   // -100 to 100, default 0
  contrast: number;     // -100 to 100, default 0
  grayscale: boolean;   // default false
  blur: number;         // 0 to 20, default 0
  sharpen: number;      // 0 to 100, default 0
  rotation: number;     // free rotation in degrees, default 0
}

export const DEFAULT_ADJUSTMENTS: Readonly<AdjustmentState> = {
  brightness: 0,
  contrast: 0,
  grayscale: false,
  blur: 0,
  sharpen: 0,
  rotation: 0,
};

export interface CropRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface EditorSnapshot {
  imageData: ImageData;
  width: number;
  height: number;
}

export type EditorEventType =
  | 'image-loaded'
  | 'image-updated'
  | 'adjustment-changed'
  | 'history-changed'
  | 'crop-mode-changed';

export type EditorEventCallback = () => void;
